export default __webpack_public_path__ + "static/media/LI.a220a268.svg";